
var accent_map = {
  'á': 'a',
  'à': 'a',
  'â': 'a',
  'å': 'a',
  'ä': 'a',
  'a': 'a',
  'ã': 'a',
  'č': 'c',
  'ç': 'c',
  'ě': 'e',
  'é': 'e',
  'è': 'e',
  'ê': 'e',
  'ë': 'e',
  'í': 'i',
  'ì': 'i',
  'î': 'i',
  'ï': 'i',
  'ñ': 'n',
  'ň': 'n',
  'ó': 'o',
  'ò': 'o',
  'ô': 'o',
  'ö': 'o',
  'õ': 'o',
  'ř': 'r',
  'š': 's',
  'ť': 't',
  'ú': 'u',
  'ù': 'u',
  'û': 'u',
  'ü': 'u'
};


export default function replaceEspecialChars(text) {
  var ret = '', s = text.toString();
  if (!s) {
    return '';
  }
  for (var i = 0; i < s.length; i++) {
    ret += accent_map[s.charAt(i)] || s.charAt(i);
  }
  return ret;
};

